import React, {FC, ReactElement, Ref} from "react";
import {Grid} from "@mui/material";
import LoadingButton from "../../../components/button/LoadingButton";
import {observer} from "mobx-react";
import {ControlDivider} from "./NewEmployeeWizard";
import FileUploadProgress, {FileUploadProgressHandle} from "../../../components/file/FileUploadProgress";
import {Trans, withTranslation} from "react-i18next";

interface IProps {
    uploadSectionRef: Ref<FileUploadProgressHandle>
    uploadFinished: boolean
    onClose: () => void
}

export const UploadSection: FC<IProps> = observer(({uploadSectionRef, uploadFinished, onClose}): ReactElement => {
    return <>
        <FileUploadProgress ref={uploadSectionRef}/>
        <ControlDivider/>
        <Grid container spacing={1}>
            <Grid item>
                <LoadingButton disabled={!uploadFinished} variant="contained" color="primary" onClick={onClose}>
                    <Trans i18nKey="common.close">Close</Trans>
                </LoadingButton>
            </Grid>
        </Grid>
    </>
});

export default withTranslation()(UploadSection);